// Copyright (c) 2019-2020 Verimatrix, Inc.  All Rights Reserved.

import React, {Component} from 'react'
import MenuItem from '..'
import ContactSupportOutlinedIcon from '@material-ui/icons/ContactSupportOutlined'


class ContentDistribution extends Component {

  render () {
    return (
      <MenuItem
        title='Product Details'
        buttonText={<><ContactSupportOutlinedIcon />Contact our sales team</>}
        href={'https://www.verimatrix.com/online-contact-form'}
      >
        <div className='content-distribution product-details'>
          <div className='row title'>
            <p>Verimatrix Content Distribution is a DRM-agnostic SaaS solution that secures multi-tier content distribution and reporting by encrypting once and delivering everywhere.</p>
          </div>
          <div className='row text'>
            <ul>
              <li className='lh'>{'Content Distribution key features include:'}</li>
              <li>{'Efficient video content distribution, by processing once and distributing to many '}</li>
              <li>{'Industry-leading protection for your content across the distribution chain'}</li>
              <li>{'Usage rights control that allows managing distribution windows and DRM policy enforcements'}</li>
              <li>{'Transparent viewer analytics helps track consumption patterns and contract compliance'}</li>
            </ul>
          </div>
        </div>
      </MenuItem>
    )
  }
}

export default (ContentDistribution)
